/*
 * @Description: 抽奖接口
 * @Author: yl
 * @Date: 2021-05-31 11:19:30
 * @LastEditTime: 2021-06-02 10:04:07
 * @LastEditors: yl
 */
import {
    ajaxP
    // ajax,
    // request
} from '@/utils/request'

// 获取用户状态
export function getUserInfo(params) {
    return ajaxP(`api/v1/luckDrawController/getLocalStatus`, params, false, false)
}

// 抽奖
export function Lottery(params) {
    return ajaxP(`api/v1/luckDrawController/getLottery`, params)
}

// 完善信息
export function inputInfo(params) {
    return ajaxP(`api/v1/luckDrawController/commit`, params)
}

// 修改信息
export function updateInfo(params) {
    return ajaxP(`api/v1/luckDrawController/updateInfo`, params)
}